<template>
  <!-- Main sidebar -->
  <div
    class="sidebar sidebar-dark sidebar-main sidebar-expand-md sidebar-menu"
    :class="showLeft ? 'sidebar-menu-admin-lg' : 'sidebar-menu-admin-sm'"
  >
    <!-- Sidebar content -->
    <div
      class="sidebar-content"
    >
      <!-- Main navigation -->
      <div class="card card-sidebar-mobile">
        <ul
          class="nav nav-sidebar pt-0"
          data-nav-type="accordion"
        >
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'backoffice.home' }"
              class="nav-link"
            >
              <i class="fas fa-home" />
            </router-link>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'backoffice.orders' }"
              class="nav-link"
            >
              <i class="fas fa-shopping-basket" />
            </router-link>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'backoffice.webhooklog' }"
              class="nav-link"
            >
              <i class="fas fa-cogs" />
            </router-link>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'backoffice.externallog' }"
              class="nav-link"
            >
              <i class="fas fa-external-link-square-alt" />
            </router-link>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'backoffice.users' }"
              class="nav-link"
            >
              <i class="fas fa-users" />
            </router-link>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'backoffice.pages' }"
              class="nav-link"
            >
              <i class="fas fa-file" />
            </router-link>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'backoffice.reports' }"
              class="nav-link"
            >
              <i class="fas fa-file-alt" />
            </router-link>
          </li>
        </ul>
      </div>
      <!-- /main navigation -->
    </div>
    <!-- /sidebar content -->
    
    <div
      class="sidebar-menu-autohide"
      :class="showLeft || $parent.hoverLogo ? 'sidebar-menu-autohide-show' : 'sidebar-menu-autohide-hide'"
    >
      <div
        class="logo-content pl-3 justify-content-between"
        style="border-bottom: none;"
      >
        <router-link
          to="/backoffice/home"
          class="d-inline-block"
        >
          <img
            :src="$storeIndex.getLogoGlobalSvgAssets('GoChat-logo')"
            alt=""
            class="logo logo-gochat-beta"
          >
        </router-link>

        <a
          class="icon-toggle-left-menu-admin"
          @click="toggleLeftMenu()"
        >
          <i
            class="fas fa-align-justify"
          />
        </a>
      </div>

      <div class="w-100">
        <ul
          class="nav nav-sidebar w-100 pt-0"
          data-nav-type="accordion"
        >
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'backoffice.home' }"
              class="nav-link pl-3"
            >
              <div class="icon-menu-sidebar-menu-admin mr-2">
                <i class="fas fa-home" />
              </div>
              <span>{{ $t("_BackofficeMenu.Home") }}</span>
            </router-link>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'backoffice.orders' }"
              class="nav-link pl-3"
            >
              <i class="fas fa-shopping-basket mr-2" />
              <span>{{ $t("_BackofficeMenu.Orders") }}</span>
            </router-link>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'backoffice.webhooklog' }"
              class="nav-link pl-3"
            >
              <div class="icon-menu-sidebar-menu-admin mr-2">
                <i class="fas fa-cogs" />
              </div>
              <span>{{ $t("_BackofficeMenu.Webhook Log") }}</span>
            </router-link>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'backoffice.externallog' }"
              class="nav-link pl-3"
            >
              <div class="icon-menu-sidebar-menu-admin mr-2">
                <i class="fas fa-external-link-square-alt" />
              </div>
              <span>{{ $t("_BackofficeMenu.External Log") }}</span>
            </router-link>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'backoffice.users' }"
              class="nav-link pl-3"
            >
              <div class="icon-menu-sidebar-menu-admin mr-2">
                <i class="fas fa-users" />
              </div>
              <span>{{ $t("_BackofficeMenu.Users") }}</span>
            </router-link>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'backoffice.pages' }"
              class="nav-link pl-3"
            >
              <div class="icon-menu-sidebar-menu-admin mr-2">
                <i class="fas fa-file" />
              </div>
              <span>{{ $t("_BackofficeMenu.Pages") }}</span>
            </router-link>
          </li>
          <li
            class="nav-item"
          >
            <router-link
              :to="{ name: 'backoffice.reports' }"
              class="nav-link pl-3"
            >
              <div class="icon-menu-sidebar-menu-admin mr-2">
                <i class="fas fa-file-alt" />
              </div>
              <span>{{ $t("_BackofficeMenu.Reports") }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { USER } from "@/vuex-store/types";
import Api from "@/services/endpoint/central.service";
import Cookies from 'js-cookie';

export default {
  name: "LeftMenu",
  data() {
    return {
      showLeft: true,
      channels: [],
      filterChatType: "",
      disableBtnGoBack: false,
    };
  },
  mounted() {
    this._getPages();
  },
  watch: {
  },
  computed: {
    ...mapGetters({
      user: USER,
    }),
  },
  methods: {
    showLeftMenu() {
      this.showLeft = true;
    },
    hideLeftMenu() {
      this.showLeft = false;
    },
    toggleLeftMenu() {
      this.showLeft = !this.showLeft;
    },
    async _getPages() {
      let pages = [];
      this.loadChatPages = true;
      try {
        const res = await Api.Chat.getPages({
          merchant_id: this.user.merchant_id,
          integration_name: this.filterChatType,
        });
        if (res) {
          if (!!res.data.data) res.data.data.map(channel => {
            pages.push(channel.integration_name)
          })
        }
      } catch (error) {
        // console.log(error);
        if (error.response && error.response.data && error.response.data.message == "token has expired") this.$storeIndex.gotoGoSaas(this);
      } finally {
        this.channels = pages;
      }
    },
    checkIntegratedChannel(ch) {
      let isShow = false;
      isShow = this.channels.includes(ch);
      return isShow;
    },
    backToGoSaas() {
      this.disableBtnGoBack = true;
      if (Cookies.get("callbackUrl"))
        location.href = Cookies.get("callbackUrl");
      // + "/app/integrations?integration_group_id=5";
      else if (process.env.GOSAAS_BASE_URL) location.href = process.env.GOSAAS_BASE_URL;
      setTimeout(() => {
        this.disableBtnGoBack = false;
      }, 500);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/backoffice/layout/template/LeftMenu.vue